module.exports = __webpack_public_path__ + "img/thumb_19.1c289410.jpg";